import React, { FC } from 'react';
import { Accordion, /* Container,*/ ListGroup } from 'react-bootstrap';
import { Action, Button, Label, Textarea } from '..';
import styles from './SortableTextBlockItem.module.css';
import { BlockItem } from '../SortableImageBlockItem/SortableImageBlockItem';
import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';

interface SortableTextBlockItemProps {
  id: string;
  changeOrderEnabled: boolean;
  blockItem: BlockItem;
  blockItems: BlockItem[];
  blockItemsLength: number;
  blockItemIndex: number;
  moveListItem: (from: number, to: number) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string, type: BlockType) => void;
}

const SortableTextBlockItem: FC<SortableTextBlockItemProps> = ({
  id,
  changeOrderEnabled,
  blockItem,
  blockItems,
  blockItemsLength,
  blockItemIndex,
  moveListItem,
  handleEdit,
  handleDelete,
}) => {
  return (
    <ListGroup.Item>
      <Accordion flush alwaysOpen defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {' '}
            <Label content={blockItem.title} size="heading-md" />
          </Accordion.Header>
          <Accordion.Body>
            <div className={styles.accordionHeader}>
              <div className={styles.sortActionsWrapper}>
                {changeOrderEnabled &&
                  blockItemsLength > 1 &&
                  blockItemIndex !== 0 && (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveListItem(
                          blockItem.sortOrder,
                          blockItems[blockItemIndex - 1].sortOrder
                        );
                      }}
                    >
                      ↑
                    </Button>
                  )}
                {changeOrderEnabled &&
                  blockItemsLength > 1 &&
                  blockItemIndex !== blockItemsLength - 1 && (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveListItem(
                          blockItem.sortOrder,
                          blockItems[blockItemIndex + 1].sortOrder
                        );
                      }}
                    >
                      ↓
                    </Button>
                  )}
              </div>
              <Textarea
                content={blockItem.content ?? ''}
                readOnly
                setContent={() => {}}
              />

              <div className={styles.crudActions}>
                <Action
                  type="edit"
                  onClick={() => handleEdit(id, blockItem.type)}
                />
                <Action
                  type="delete"
                  itemName={blockItem.title}
                  onClick={() => handleDelete(id)}
                />
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </ListGroup.Item>
  );
};

export default SortableTextBlockItem;
